import React, { useState, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { connect } from 'react-redux'
import { setUIForwardAction, setReservationIdAction, setDriver1BirthDateAction } from '../../actions'
import { getCSCId } from '../../actions/api'
import { UI } from '../../constants/ui'
import DevTools from '../DevTool'
import './footer.less'
import logo from '../../assets/logo.png'
import exitsymbol from '../../assets/exit-symbol.png'
import eng from '../../assets/flags/eng.png'
import fin from '../../assets/flags/fin.png'
import est from '../../assets/flags/est.png'
import sve from '../../assets/flags/sve.png'
import lat from '../../assets/flags/lat.png'
import rus from '../../assets/flags/rus.png'
import pol from '../../assets/flags/pol.png'

const SHOW_ID_DURATION = 3000
const langs = [
  { img: eng, code: 'en' },
  { img: est, code: 'et' },
  { img: fin, code: 'fi' },
  { img: sve, code: 'sv' },
  { img: lat, code: 'lv' },
  { img: rus, code: 'ru' },
  { img: pol, code: 'pl' },
]
interface DispatchProps {
  setUI: (ui: UI) => void
  setReservationId: (value: string) => void
  setDriver1BirthDate: (value: string) => void
}
const mapDispatchToProps = (dispatch: any): DispatchProps => ({
  setUI: (ui: UI): void => dispatch(setUIForwardAction(ui)),
  setReservationId: (value: string): void => dispatch(setReservationIdAction(value)),
  setDriver1BirthDate: (value: string): void => dispatch(setDriver1BirthDateAction(value)),
})
interface OwnProps {
  noExit?: boolean
}

type Props = DispatchProps & OwnProps

let showIdTimer: any = null

const Footer: React.FC<Props> = ({ setUI, noExit, setReservationId, setDriver1BirthDate }: Props) => {
  const { i18n, t } = useTranslation()
  const [showDevTools, setShowDevTools] = useState(false)
  const [showId, setShowId] = useState(false)
  useEffect(() => {
    return () => {
      showIdTimer && clearTimeout(showIdTimer)
    }
  }, [])
  const buttonExitClick = () => {
    setReservationId('')
    setDriver1BirthDate('')
    setUI(UI.MAIN)
  }
  const toggleDevTools = (value: boolean) => {
    const testMode = window.location.search.includes('test-mode')
    if (testMode) {
      setShowDevTools(value)
    } else {
      if (showIdTimer) {
        clearTimeout(showIdTimer)
        showIdTimer = null
        setShowId(false)
      } else {
        setShowId(true)
        showIdTimer = setTimeout(() => {
          setShowId(false)
          showIdTimer = null
        }, SHOW_ID_DURATION)
      }
    }
  }
  return (
    <div className="footer">
      <img className="logo" src={logo} alt="logo" onClick={() => toggleDevTools(!showDevTools)} />
      <div className="flags">
        {langs.map((item) => (
          <img
            className="flag"
            src={item.img}
            key={item.code}
            alt="flag"
            onClick={() => i18n.changeLanguage(item.code)}
          />
        ))}
      </div>
      {!noExit && (
        <button className="exit-button" onClick={() => buttonExitClick()}>
          {t('exit')} <img className="exitsymbol" src={exitsymbol} alt="exitsymbol" />
        </button>
      )}
      {showDevTools && <DevTools onClose={() => toggleDevTools(false)} />}
      {showId && <div className="csc-id">{getCSCId()}</div>}
    </div>
  )
}

export default connect(null, mapDispatchToProps)(Footer)
